export default (skills, [selectedSkills, toggleSkill]) => {
  const skillIsSelected = (s) => selectedSkills.find((s_) => s_.id === s.id)
  return skills.map((s) => ({
    title: s.name,
    key: `skill-${s.id}`,
    onPress: () => toggleSkill(s),
    selected: skillIsSelected(s),
  }))
}
